var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuLocale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.067,
    height: 14,
    viewBox: "0 0 15.067 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35882",
    "data-name": "Group 35882",
    transform: "translate(-1.5 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39609",
    "data-name": "Path 39609",
    d: "M11.7,5.7H2.1a.6.6,0,1,1,0-1.2h9.6a.6.6,0,1,1,0,1.2Z",
    transform: "translate(0 -0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39610",
    "data-name": "Path 39610",
    d: "M8.85,5.05a.6.6,0,0,1-.6-.6V2.85a.6.6,0,0,1,1.2,0v1.6A.6.6,0,0,1,8.85,5.05Z",
    transform: "translate(-1.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39611",
    "data-name": "Path 39611",
    d: "M19,18.417a.6.6,0,0,1-.552-.364L15.8,11.873l-2.648,6.18a.6.6,0,0,1-1.1-.473l3.2-7.467a.6.6,0,0,1,1.1,0l3.2,7.467a.6.6,0,0,1-.551.836Z",
    transform: "translate(-3.033 -2.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39612",
    "data-name": "Path 39612",
    d: "M18.416,18.45H13.983a.6.6,0,1,1,0-1.2h4.433a.6.6,0,1,1,0,1.2Z",
    transform: "translate(-3.433 -4.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39613",
    "data-name": "Path 39613",
    d: "M3.6,14.767A.6.6,0,0,1,3.3,13.65,16.341,16.341,0,0,0,7.1,10.22,15.841,15.841,0,0,0,9.729,4.95a.6.6,0,1,1,1.162.3,16.856,16.856,0,0,1-2.86,5.729,17.229,17.229,0,0,1-4.126,3.7A.6.6,0,0,1,3.6,14.767Z",
    transform: "translate(-0.433 -0.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39614",
    "data-name": "Path 39614",
    d: "M10.116,14.033a.6.6,0,0,1-.366-.125A15.468,15.468,0,0,1,7.241,11.3,21.089,21.089,0,0,1,5.316,8.374a.6.6,0,1,1,1.067-.548,20.326,20.326,0,0,0,1.808,2.741,14.562,14.562,0,0,0,2.292,2.392.6.6,0,0,1-.368,1.075Z",
    transform: "translate(-1.083 -1.517)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLocale);
export default __webpack_public_path__ + "static/media/menu-locale.e91cbb212e4f3023918de6aded20a084.svg";
export { ForwardRef as ReactComponent };